export const ItemTypes = {
  OPTION: 'option',
  CRITERION: 'criterion',
}

export const TaskTypes = {
  TASK: "Task",
  TASK_PACKAGE: "TaskPackage"
}

export const initialViewState = () => {
  return JSON.parse(JSON.stringify(
    {
      mainDrawerOpen: true,
      saveDialogOpen: false,
      projectDialogOpen: false,
      createNewProjectDialogOpen : false,
    }));
}

export const retryConfigDefaults = {
  maxRetries: 5,
  initialDelay: 1000,
  retryableStatuses: [503, 504]
}

export const initialProject = () => {
  return JSON.parse(JSON.stringify(
    {
      name: '',
      id: '',
      folderName : 'undefined',
      ownerName: '',
    }));
}

export const TestProject = () => {
  const sampleProject = {
    id: 'none',
    name:'Please Open a Project',
    folderName : 'free',
    ownerName: '',
    rootTaskPackage: {},
  }
  sampleProject.rootTaskPackage = {
    id: "root",
    name: 'Task Root',
    project: sampleProject,
    actualProgress: [],
    plannedProgress: [],
    tasks: [],
    taskPackages: [],
  }
  sampleProject.rootTaskPackage.tasks.push(
    {id:'foo', name:'Foo', plannedCost:56812, plannedDuration:70, actualProgress: [], plannedProgress: []}
  );
  sampleProject.rootTaskPackage.tasks[0].actualProgress.push(
    {period:1, progress:2, actualCost:15000, note:'This is the note.'}
  )
  sampleProject.rootTaskPackage.tasks[0].actualProgress.push(
    {period:2, progress:3, actualCost:17000, note:null}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:1, expectedProgress:9, expectedCost:17000, periodWeight:0.5, nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:2, expectedProgress:9, expectedCost:17000, periodWeight:1, nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:3, expectedProgress:0, expectedCost:0, periodWeight:1, nonWorkingPeriod:true}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:4, expectedProgress:9, expectedCost:17000, periodWeight:1, nonWorkingPeriod:false}
  )  
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:5, expectedProgress:0, expectedCost:0, periodWeight:1,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:6, expectedProgress:9, expectedCost:17000, periodWeight:1,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:7, expectedProgress:9, expectedCost:17000,  periodWeight:1,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:8, expectedProgress:9, expectedCost:17000,  periodWeight:1,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:9, expectedProgress:9, expectedCost:17000,  periodWeight:1,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks[0].plannedProgress.push(
    {period:10, expectedProgress:9, expectedCost:17000, periodWeight:0.5,  nonWorkingPeriod:false}
  )
  sampleProject.rootTaskPackage.tasks.push(
    {id:'bar', name:'Bar', plannedCost:1500000, plannedDuration:200, actualProgress: [], plannedProgress: []}
  );
  sampleProject.rootTaskPackage.tasks.push(
    {id:'baz', name:'Baz', plannedCost:2000000, plannedDuration:110, actualProgress: [], plannedProgress: []}
  );
  sampleProject.rootTaskPackage.taskPackages.push(
    {
      id: "precon",
      name: 'Pre-Construction',
      project: sampleProject,
      tasks: [],
      plannedProgress : [],
      taskPackages: [],
    }
  );
  sampleProject.rootTaskPackage.taskPackages[0].tasks.push(
    {id:'fred', name:'Fred', plannedCost:250000, plannedDuration:22, plannedStartDate: '2020-02-14', plannedEndDate : '2020-03-17', actualProgress: [], plannedProgress: []}
  );
  return sampleProject;
}